import React, { useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { formatTotalHours, getAllMonths, getAllYears, getFieldData, getMonthLastDay, getMonthName, getTotalDays, getTotalHours } from "../../../services/appService";
import { getAlert } from "../../../services/appAlerts";
import { getTimeLogDuration, getTimeLogs, loadTimeLogDuration, loadTimeLogs } from "../../store/timeLog";
import { getTimeLogInvoice, loadTimeLogInvoice } from "../../store/timeLogInvoice";
import AddNewTimeLog from "../../../components/OMCRegistry/AddNewTimeLog";
import CandidatePay from "../../../components/OMCRegistry/CandidatePay";
import UploadInvoice from "../../../components/OMCRegistry/UploadInvoice";
import { getCandidateApps, loadCandidateApps } from "../../store/candidate";
import { getCurrentUser } from "../../store/auth";
import useDocDownload from "../../hooks/useDocDownload";

export default function Agency(props) {
    const { candidate, ptype, entType, wfTask } = props;

    const [timeLogs, setTimeLogs] = useState([]);
    const [timeLogInvoices, setTimeLogInvoices] = useState([]);
    const [applications, setApplications] = useState([]);
    const [timeLogShowHide, setTimeLogShowHide] = useState(false);
    const [projectStartDate, setProjectStartDate] = useState("");
    const [projectStDt, setProjectStDt] = useState("");
    const [currentStDt, setCurrentStDt] = useState("");
    const [payShowHide, setPayShowHide] = useState(false);
    const [invShowHide, setInvShowHide] = useState(false);
    const [invType, setInvType] = useState("agency");
    const [timeLogObj, setTimeLogObj] = useState("");
    const [filterYear, setFilterYear] = useState("");
    const [filterMonth, setFilterMonth] = useState("");
    //const [workItem, setWorkItem] = useState(null);

    const timeLogsSelector = useSelector(getTimeLogs);
    const timeLogsInvoiceSelector = useSelector(getTimeLogInvoice);
    const candidateAppsSelector = useSelector(getCandidateApps);
    const timeLogDurationSelector = useSelector(getTimeLogDuration);

    const years = getAllYears();
    const months = getAllMonths();
    const perfData = candidate?.performerData;
    const agencyRate = candidate.rates?.agencyRate;
    const agencyDate = candidate.rates?.agencyEffectiveDate;

    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (candidate?.id) {
            dispatch(loadTimeLogs(candidate.id));
            dispatch(loadTimeLogInvoice(candidate.id));
            dispatch(loadTimeLogDuration(candidate.id));
            // if (candidate.applications.length > 0) {
            //     const app = candidate.applications[0];
            //     dispatch(loadCandidateApps(candidate.id, "admin", currentUser.id, app.ciid));
            // }
        }
    }, [candidate]);

    // useEffect(() => {
    //     if (candidateAppsSelector.length > 0) {
    //         setApplications(candidateAppsSelector);
    //         const allTasks = candidateAppsSelector[0].workflowTasks.filter(
    //             (x) =>
    //                 x.itemType === 1 &&
    //                 x.applicantId !== x.performerId &&
    //                 x.taskDoneStatus > 0
    //         );
    //         const tsk = allTasks[allTasks.length - 1];
    //         setWorkItem(tsk);
    //     }
    // }, [candidateAppsSelector]);

    useEffect(() => {
        setTimeLogs(timeLogsSelector)
    }, [timeLogsSelector]);

    useEffect(() => {
        if (timeLogsInvoiceSelector.length > 0) {
            const subcontractorInvoices = timeLogsInvoiceSelector.filter(x => x.invoiceType === invType);
            setTimeLogInvoices(subcontractorInvoices)
        }
        if (timeLogDurationSelector?.startDate) {
            const startDate = new Date(timeLogDurationSelector.startDate);
            startDate.setDate(startDate.getDate() + 1); // add 1 day
            const result = startDate.toISOString().substring(0, 10);
            setProjectStDt(startDate);
            setCurrentStDt(timeLogDurationSelector.projectStartedDate);
        }
    }, [timeLogsInvoiceSelector, timeLogDurationSelector]);

    useEffect(() => {

        let filterTimeLogs = [...timeLogsSelector];
        if (filterYear > 0)
            filterTimeLogs = filterTimeLogs.filter(x => x.year === parseInt(filterYear));

        if (filterMonth > 0)
            filterTimeLogs = filterTimeLogs.filter(x => x.month === parseInt(filterMonth));

        setTimeLogs(filterTimeLogs);

    }, [filterMonth, filterYear]);

    const getMonthlyPeriod = (obj) => {
        if (!obj?.workingHrs) return "";
        const wt = JSON.parse(obj.workingHrs);
        const sortWt = wt.sort((a, b) => new Date(a.start) - new Date(b.start));
        if (sortWt.length > 0) {
            return (
                <div>
                    <Moment format="MM/DD/YYYY">{sortWt[0].start}</Moment>-
                    <Moment format="MM/DD/YYYY">
                        {sortWt[sortWt.length - 1].type === "m"
                            ? getMonthLastDay(sortWt[sortWt.length - 1].start)
                            : sortWt[sortWt.length - 1].start}
                    </Moment>
                </div>
            );
        }

        return "";
    };

    const getAgencyInvoice = (item) => {
        const tmLogs = timeLogInvoices
            .filter(
                (x) =>
                    x.timeLogId === item.id &&
                    x.invDoc !== null
            );

        if (tmLogs.length === 0) {
            return <button
                className="btn btn-sm btn-link p-0"
                onClick={() => handleInvShowHide(item)}
            >
                Upload
            </button>
        }

        return <>
            {tmLogs.map((inv) => (
                <React.Fragment>
                    {inv.invoiceNumber}
                    <br />
                    <button
                        className="btn btn-sm btn-link p-0"
                        onClick={() =>
                            handleDownloadFile(
                                inv.invDoc
                            )
                        }
                    >
                        {inv.invDoc.documentName}
                    </button>
                    <br />
                    <Moment format="MMM Do YYYY, h:mm a">
                        {inv.addedDateTime}
                    </Moment>
                </React.Fragment>
            ))}
        </>
    }


    const getInvoiceAmount = (item) => {
        const totHrs = getTotalHours(item?.workingHrs || 0);

        let invAmt = totHrs * agencyRate;

        // If not W2, return straight amount
        if (entType !== "W2 Basis") {
            return parseFloat(invAmt || 0).toFixed(2);
        }

        // W2 → add tax
        const taxRate = (getFieldData(perfData, "candidateonboardingform", "Tax") || 0) / 100;
        invAmt = invAmt + invAmt * taxRate;

        return parseFloat(invAmt || 0).toFixed(2);
    };

    const getFinalAmout = (obj) => {
        let fAmt = parseFloat(getInvoiceAmount(obj));
        const invItems = timeLogInvoices.filter(
            (x) => x.timeLogId === obj.id
        );
        if (invItems.length > 0) {
            const item = invItems[0];
            if (item?.adjustmentMinues > 0)
                fAmt -= item.adjustmentMinues;
            if (item?.adjustmentPlus > 0)
                fAmt += item.adjustmentPlus;
            if (item?.adpDeduction > 0)
                fAmt -= item.adpDeduction;
            return parseFloat(fAmt || 0).toFixed(2);
        } else {
            return parseFloat(fAmt || 0).toFixed(2);
        }
    };

    const getPaymentStatus = (item) => {
        const tmLogs = timeLogInvoices.filter(
            (x) =>
                x.timeLogId === item.id &&
                x.paymentMode !== null
        );

        if (tmLogs.length === 0) {
            return <button
                className="btn btn-link btn-sm p-0"
                onClick={() => handlePayShowHide(item)}
            >
                Pending
            </button>
        }

        return <>
            {tmLogs.map((pay) => (
                <React.Fragment>
                    <button
                        className="btn btn-link btn-sm p-0"
                        onClick={() => handlePayShowHide(item)}
                    >
                        Received
                    </button>
                    <br />
                    {pay?.docList?.map((doc) => (
                        <button
                            className="btn btn-sm btn-link p-0"
                            onClick={() =>
                                handleDownloadFile(
                                    doc
                                )
                            }
                        >
                            {doc.documentName}
                        </button>
                    ))}

                    {pay?.docList?.length > 0 && <br />}
                    <Moment format="MMM Do YYYY">
                        {pay.addedDateTime}
                    </Moment>
                    <br />
                    Received : {parseFloat(pay.paidAmount || 0).toFixed(2) || 0}
                </React.Fragment>
            ))}
        </>
    }

    const getDueAmountStatus = (item) => {
        const tmLogs = timeLogInvoices.filter(
            (x) => x.timeLogId === item.id && x.paidAmount !== null
        );

        if (tmLogs.length === 0) return "";

        const finalAmount = parseFloat(getFinalAmout(item));
        const validFinalAmount = isNaN(finalAmount) ? 0 : finalAmount;

        return (
            <>
                {tmLogs.map((inv, index) => {
                    const paid = parseFloat(inv.paidAmount);
                    const validPaid = isNaN(paid) ? 0 : paid;
                    const due = (validFinalAmount - validPaid).toFixed(2);
                    return <span key={index}>{due}</span>;
                })}
            </>
        );
    };


    const handleShowHide = async (obj) => {
        if (obj === "save") {
            setTimeLogShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogs(candidate.id));
        } else {
            setTimeLogShowHide(!timeLogShowHide);

            setTimeLogObj(obj);
        }
    };

    const handlePayShowHide = async (obj) => {
        if (obj === "save") {
            setPayShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate?.id))
        } else {
            if (obj === "close") {
                setPayShowHide(false);
                setTimeLogObj("");
            } else {
                const chkInvoice = timeLogInvoices.filter(
                    (x) =>
                        x.timeLogId === obj.id && x.invDoc !== null
                );
                // if (chkInvoice.length > 0 || entType !== "C2C Basis") {
                if (chkInvoice.length > 0) {
                    setPayShowHide(!payShowHide);
                    setTimeLogObj(obj);
                } else {
                    getAlert("", "Invoice not generated", "error");
                }
            }
        }
    };

    const handleInvShowHide = async (obj) => {
        if (obj === "save") {
            setInvShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate.id));
        } else {
            setInvShowHide(!invShowHide);
            setTimeLogObj(obj);
        }
    };

    return <React.Fragment>

        <div className="row">
            <div className="col-md-3 form-group">
                <select
                    name="filterYear"
                    id="filterYear"
                    className="form-control form-control-sm"
                    aria-label="Select Year"
                    value={filterYear}
                    onChange={({ currentTarget }) => setFilterYear(currentTarget.value)}
                >
                    <option value="">Year</option>
                    {years.map((y) => (
                        <option value={y.name}>{y.name}</option>
                    ))}
                </select>
            </div>

            <div className="col-md-3 form-group">
                <select
                    name="filterMonth"
                    id="filterMonth"
                    className="form-control form-control-sm"
                    aria-label="Select Month"
                    value={filterMonth}
                    onChange={({ currentTarget }) => setFilterMonth(currentTarget.value)}
                >
                    <option value="">Month</option>
                    {months.map((m) => (
                        <option value={m.id}>{m.name}</option>
                    ))}
                </select>
            </div>

            <div className="col-md-12">
                <div className="table-responsive">
                    <table className="table align-items-center table-flush table-striped mb-2 border">
                        <thead className="thead-light">
                            <tr>
                                <th>Year</th>
                                <th>Month</th>
                                <th>Time<br />Logged</th>
                                <th>Hrs<br />Days</th>
                                <th>Rate/Hr ($)</th>
                                <th>Invoice<br />Amount ($)</th>
                                <th>Upload<br />Invoice</th>
                                <th>Payment<br />Status</th>
                                {/* <th>Due Amount</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {timeLogs.map((item) => (
                                <tr>
                                    <td>{item.year}</td>
                                    <td>{getMonthName(item.month)}</td>
                                    <td>{getMonthlyPeriod(item)}
                                        <button
                                            className="btn btn-sm btn-link p-0"
                                            onClick={() => handleShowHide(item)}
                                        >
                                            View
                                        </button>
                                        <br />
                                        {item.docList.map((doc) => (
                                            <li className="list-group-item p-0 border-0 bg-transparent">
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={() => handleDownloadFile(doc)}
                                                >
                                                    {doc.documentName.length > 15
                                                        ? doc.documentName.substring(0, 15) + "..."
                                                        : doc.documentName}
                                                </button>
                                            </li>
                                        ))}
                                    </td>

                                    <td>
                                        <i className="fa fa-clock-o" /> {formatTotalHours(item?.workingHrs)}
                                        <br />
                                        {getTotalDays(item?.workingHrs) + " Days"}
                                    </td>
                                    <td>
                                        {parseFloat(agencyRate || 0).toFixed(2) || 0}
                                        <br />
                                        {agencyDate && (
                                            <Moment format="MM/DD/YYYY">
                                                {agencyDate}
                                            </Moment>
                                        )}
                                    </td>
                                    <td>
                                        {Number(parseFloat(getTotalHours(item?.workingHrs) * agencyRate).toFixed(2)).toLocaleString("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </td>
                                    <td>
                                        {getAgencyInvoice(item)}
                                    </td>
                                    <td>
                                        {getPaymentStatus(item)}
                                    </td>
                                    {/* <td>
                                        {getDueAmountStatus(item)}
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <UploadInvoice
            invShowHide={invShowHide}
            handleInvShowHide={handleInvShowHide}
            selectedObj={timeLogObj}
            candidateObj={candidate}
            wfTask={wfTask}
        ></UploadInvoice>



        <CandidatePay
            payShowHide={payShowHide}
            handlePayShowHide={handlePayShowHide}
            candidateObj={candidate}
            selectedObj={timeLogObj}
            invType={invType}
            timeLogInvoices={timeLogInvoices}
            getInvoiceAmount={getInvoiceAmount}
            entType={entType}
            wfTask={wfTask}
        ></CandidatePay>

        {timeLogShowHide &&
            <AddNewTimeLog
                showHide={timeLogShowHide}
                handleShowHide={handleShowHide}
                selectedObj={timeLogObj}
                allTimeLogs={timeLogs}
                candidateObj={candidate}
                timeLogInvoices={timeLogInvoices}
                projectStartDate={projectStDt}
            ></AddNewTimeLog>
        }

    </React.Fragment>
}